import isPropValid from '@emotion/is-prop-valid';
import { WebTarget } from 'styled-components';

export function shouldForwardProp(prop: string, target: WebTarget) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(prop);
  }
  // For other elements, forward all props
  return true;
}
